import { createGtm } from '@gtm-support/vue-gtm';

import CustomEvents from './custom-events';
import EcommerceEvents from './ecommerce-events';

import logger from '@/services/logger';
import returnAppConfig from '@/helpers/return-app-config';


const customConsoleLogStyles = [
  'color: #5186EC; font-weight: bold',
  'color: #D85040; font-weight: bold',
  'color: #F1BD42; font-weight: bold',
  'color: #5186EC; font-weight: bold',
  'color: #58A55C; font-weight: bold',
  'color: #D85040; font-weight: bold',
  'color: inherit',
  'color: #fff; padding: 1px 4px; background: #3B873E; border-radius: 4px',
  'color: inherit'
];


class GoogleTagManager {
  constructor(customEvents, ecommerceEvents) {
    this.customEvents = customEvents;

    this.ecommerceEvents = ecommerceEvents;
  }

  static init({ store, router, app }) {
    const { externalGoogleTagManagerId } = store.state.merchant.options;

    const { googleTagManagerTrackingId, isTestEnvironment } = returnAppConfig();

    const tagManagerIds = [googleTagManagerTrackingId, externalGoogleTagManagerId].filter(id => !!id);

    try {
      if (tagManagerIds.length === 0) {
        const error = new Error('Missing Google Tag Mangager container ids');

        throw error;
      }

      const vueGtmConfig = {
        id: tagManagerIds,
        defer: false,
        enabled: true,
        debug: isTestEnvironment,
        loadScript: true,
        vueRouter: router
      };

      const gtmPlugin = createGtm(vueGtmConfig);

      app.use(gtmPlugin);

      const gtmInstance = app.config.globalProperties.$gtm;

      if (isTestEnvironment && gtmInstance.enabled()) {
        logger.log(
          `%cG%co%co%cg%cl%ce%c Tag Manager %cInitialized%c with ${tagManagerIds.join(', ')}`,
          ...customConsoleLogStyles
        );
      }

      const customEvents = CustomEvents.init(gtmInstance);

      const ecommerceEvents = EcommerceEvents.init(gtmInstance, store);

      return new GoogleTagManager(customEvents, ecommerceEvents);
    }
    catch (error) {
      logger.log(error);

      return { postEvent: () => {} };
    }
  }

  postEvent(event, eventData) {
    this.ecommerceEvents.post(event, eventData);

    // TODO: call this.customEvents.post(event, eventData), once custom event data has been defined by Product Team.
  }
}

export default GoogleTagManager;

